<template>
  <div class="rsvp page">
    <p class="p">
      Food Options
    </p>
    <h2 class="h3">
      Appetizer:
    </h2>
    <p class="p">
      Mini baked brie with almonds &amp; wild berry compote (Only 1 option,
      please specify any allergies in the comment box below for substitute)
    </p>
    <p class="h3">
      Main Course:
    </p>
    <p class="p">
      (Please specify any allergies and if you require a Vegetarian or Vegan
      Option)
    </p>
    <p class="p">
      Option 1: Grilled 8oz AAA strip loin with blueberry bourbon sauce and
      pickled radish, served with diced sweet potatoes, and roasted root
      vegetables
    </p>
    <p class="p">
      Option 2: Duck leg confit with Cherry Port sauce, served with paprika and
      herb roasted potatoes, and honey orange glazed rainbow carrots
    </p>
    <p class="h3">
      Dessert:
    </p>
    <p class="p">
      (please specify any allergies in the comment box below for substitute)
    </p>
    <p class="p">
      Option 1: Peanut butter chocolate mousse with crushed peanut butter cups
    </p>
    <p class="p">
      Option 2: Creme Brulee
    </p>
    <div class="success" v-if="rsvp">
      <p class="p">
        Thank you for choosing your food options. We look forward to seeing you
        in August.
      </p>
    </div>
    <div class="guest" v-for="guest in guests" :key="guest">
      <h1 class="h1" v-text="'Wedding Guest ' + guest" />
      <div class="question">
        <label for="name">Full Name:</label>
      </div>
      <div class="answer">
        <input
          class="text-input"
          type="text"
          v-model.lazy="guestList[guest - 1].name"
        />
      </div>
      <div class="question">
        <label for="kidsMeal">Is this a kids Meal?:</label>
      </div>
      <div class="answer">
        <input
          class="checkbox"
          type="checkbox"
          v-model.lazy="guestList[guest - 1].kidsMeal"
        />
      </div>
      <div class="question">
        <label for="allergies">
          Please list any food allergies and if you require a Vegetarian or
          Vegan Option:
        </label>
      </div>
      <div class="answer">
        <textarea
          class="textarea"
          v-model.lazy="guestList[guest - 1].allergies"
        />
      </div>
      <div class="question">
        <label for="mainCourse">Main Course:</label>
      </div>
      <div class="answer">
        <div class="radio-block">
          <input
            class="radio-button"
            type="radio"
            id="beef"
            :name="'mainCourse-' + guest"
            value="Beef"
            v-model="guestList[guest - 1].mainCourse"
          />
          <label for="beef">
            Option 1: Grilled 8oz AAA strip loin
          </label>
        </div>
        <div class="radio-block">
          <input
            class="radio-button"
            type="radio"
            id="duck"
            :name="'mainCourse-' + guest"
            value="Duck"
            v-model="guestList[guest - 1].mainCourse"
          />
          <label for="duck">
            Option 2: Duck leg confit
          </label>
        </div>
      </div>
      <div class="question">
        <label for="dessert">Dessert:</label>
      </div>
      <div class="answer">
        <div class="radio-block">
          <input
            class="radio-button"
            type="radio"
            id="mousse"
            :name="'dessert-' + guest"
            value="Mousse"
            v-model="guestList[guest - 1].dessert"
          />
          <label for="mousse">
            Option 1: Peanut butter chocolate mousse with crushed peanut butter
            cups
          </label>
        </div>
        <div class="radio-block">
          <input
            class="radio-button"
            type="radio"
            id="creme-brulee"
            :name="'dessert-' + guest"
            value="Creme Brulee"
            v-model="guestList[guest - 1].dessert"
          />
          <label for="creme-brulee">Option 2: Creme Brulee</label>
        </div>
      </div>
    </div>
    <div class="success" v-if="rsvp">
      <p class="p">
        Thank you for choosing your food options. We look forward to seeing you
        in August.
      </p>
    </div>
    <button class="button" @click="newGuests">
      <p class="button-text">Submit</p>
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "rsvp",
  computed: {
    ...mapGetters(["rsvp"]),
    guests() {
      return parseInt(this.$route.query.guests);
    },
    guestList() {
      let list = [];
      for (var guest = 0; guest < this.guests; guest++) {
        let details = {
          name: "",
          kidsMeal: false,
          allergies: "",
          mainCourse: "Beef",
          dessert: "Mousse"
        };
        list.push(details);
      }
      return list;
    }
  },
  methods: {
    newGuests() {
      this.loading = true;
      if (this.loading === true) {
        try {
          this.$store.dispatch("newGuests", this.guestList);
        } catch (error) {
          this.loading = false;
          this.error = error;
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "src/scss/base.scss";

.rsvp {
  max-width: 515px;
}

.success {
  flex: 1 0 100%;
  background: #24bb19;
  border-radius: 6px;
  color: white;
  padding: 12px 18px 2px;
  margin: 22px 0;
}

.guest {
  margin: 48px 0;
}

.question {
  margin-bottom: 10px;
}

.answer {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 28px;
}

.text-input {
  flex: 1;
  padding: 6px 8px;
  font-family: "Cinzel", serif;
}

.textarea {
  flex: 1;
  padding: 6px 8px;
  font-family: "Cinzel", serif;
}

.checkbox {
  margin-left: 0;
}

.radio-block {
  flex: 1 0 100%;
  margin-bottom: 12px;
}

.radio-button {
  margin: 3px 8px 3px 0;
}

.button {
  box-shadow: inset 0px 1px 0px 0px #ffffff;
  background: linear-gradient(to bottom, #8e8e8e 5%, #333333 100%);
  background-color: #333333;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  display: inline-block;
  cursor: pointer;
  color: #f7f7f7;
  font-family: "Cinzel", serif;
  font-size: 16px;
  font-weight: bold;
  padding: 10px 27px;
  text-decoration: none;
  text-shadow: 0px 1px 0px #ffffff;
  margin-bottom: 68px;
}
.button:hover {
  background: linear-gradient(to bottom, #333333 5%, #8e8e8e 100%);
  background-color: #333333;
}
.button:active {
  position: relative;
  top: 1px;
}

.button-text {
  display: inline-block;
}
</style>
